import React from 'react';
const contributors = [{
  name: 'שירה לוי',
  role: 'עורכת ראשית',
  img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=100&auto=format&fit=crop'
}, {
  name: 'יונתן כהן',
  role: 'כתב תרבות',
  img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=100&auto=format&fit=crop'
}, {
  name: 'ד״ר יעל שטרן',
  role: 'הגות ופילוסופיה',
  img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=100&auto=format&fit=crop'
}, {
  name: 'מיכל אהרוני',
  role: 'מבקרת אמנות',
  img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=100&auto=format&fit=crop'
}, {
  name: 'עומר שפירא',
  role: 'צלם מערכת',
  img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=100&auto=format&fit=crop'
}, {
  name: 'נועה פלד',
  role: 'עיצוב וקריאייטיב',
  img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=100&auto=format&fit=crop'
}];
export function Contributors() {
  return <section className="px-4 md:px-8 py-16 md:py-24 border-b border-ink/20" data-id="element-14">
      <div className="max-w-7xl mx-auto" data-id="element-15">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 border-b border-ink/20 pb-4 gap-4" data-id="element-16">
          <h3 className="font-sans text-2xl font-bold text-ink" data-id="element-17">
            הכותבים שלנו
          </h3>
          <p className="font-sans text-sm text-ink-soft max-w-sm" data-id="element-18">
            הקולות שמרכיבים את הגיליון הנוכחי. אנשי רוח, חוקרים, יוצרים ואמנים
            שמביאים נקודת מבט ייחודית על המציאות הישראלית.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8" data-id="element-19">
          {contributors.map((contributor, i) => <div key={i} className="flex flex-col items-center text-center group cursor-pointer" data-id="element-20">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden mb-4 border border-ink/10 group-hover:border-vermillion transition-colors" data-id="element-21">
                <img src={contributor.img} alt={contributor.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-22" />
              </div>
              <h4 className="font-serif text-xl font-bold text-ink group-hover:text-vermillion transition-colors" data-id="element-23">
                {contributor.name}
              </h4>
              <span className="font-sans text-xs text-ink-soft mt-1" data-id="element-24">
                {contributor.role}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}